<template>
  <v-dialog
    v-model="dialog"
    width="450"
  >
    <v-card>
      <v-card-title>
        Generar liquidación
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="pt-6">
          <v-col cols="5">
            <v-autocomplete
              v-model="familia"
              label="Empresa"
              item-value="id"
              item-text="nombre"
              :items="familias"
              hide-details
              outlined
              dense
              @change="periodo = null; periodo_valido = false"
            ></v-autocomplete>
          </v-col>
          <v-col cols="5"
            v-if="familia != null"
          >
            <PeriodoPicker
              v-model="periodo"
              :label="true"
              @selecciono="valdiar_periodo"
            />
          </v-col>
          <v-col cols="12" class="py-0">
            Débitos automáticos
            <v-card outlined>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="d-flex pb-0">
                    <v-btn
                      color="green darken-3"
                      :disabled="!periodo_valido"
                      :dark="periodo_valido"
                      small
                      @click="$refs.input.click()"
                    >
                      <v-icon small left>fas fa-folder-open</v-icon>
                      Seleccionar archivo
                      <input
                        ref="input"
                        type="file"
                        class="d-none"
                        :accept="tipos_validos.join(',')"
                        @change="validar_archivo($event)"
                      >
                    </v-btn>
                    <!-- descargar modelo -->
                    <download-excel
                      name="Modelo de débitos automáticos.xls"
                      :data="[{a:'',b:'',c:''}]"
                      :fields="{
                        'Suscripción': 'a',
                        'Col 1': 'b',
                        'Col 2': 'c'
                      }"
                    >
                      <v-btn
                        color="indigo"
                        class="ml-2"
                        style="min-width: 30px"
                        title="Descargar modelo de los débitos automáticos"
                        small
                        dark
                      >
                        <v-icon small>fas fa-file-download</v-icon>
                      </v-btn>
                    </download-excel>
                  </v-col>
                  <v-col cols="12" class="pt-1 pb-2 body-2 font-weight-bold">
                    <div
                      v-if="nombre_archivo"
                      class="mt-2"
                    >
                      <v-icon
                        color="green darken-3"
                        class="ml-1"
                        style="margin-bottom: 2px"
                        small
                        left
                      >
                        fas fa-file-excel
                      </v-icon>
                      {{ nombre_archivo }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-end pb-4">
        <v-btn
          color="error"
          class="mr-2"
          @click="dialog = false"
        >
          Cancelar
        </v-btn>
        <BtnConfirmar
          nombre="Generar"
          icono="fas fa-upload"
          :texto="`¿Está seguro que desea <strong>generar</strong> la liquidación para el periodo <strong>${periodo}</strong>?`"
          :disabled="!periodo_valido"
          @action="generar()"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { read, utils } from 'xlsx'
import { tipos_archivos } from '../../util/utils'
import PeriodoPicker from '../util/PeriodoPicker'
import BtnConfirmar from '../util/BtnConfirmar'

export default {
  data () {
    return {
      periodo: null,
      familia: null,
      debitos: [],
      periodo_valido: false,
      nombre_archivo: '',
      tipos_validos: ['.xls', '.xlsx', '.ods']
    }
  },
  props: {
    value: Boolean
  },
  computed: {
    ...mapState(['familias']),
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  components: {
    PeriodoPicker,
    BtnConfirmar
  },
  watch: {
    dialog (val) {
      if (val) {
        this.familia = null
        this.periodo = null
        this.debitos = []
        this.periodo_valido = false
        this.nombre_archivo = ''
      }
    }
  },
  methods: {
    async generar () {
      this.$store.state.loading = true
      try {
        // actualiza la cartera desde xpandiva
        await this.$store.dispatch('cartera/actualizar_xpansiva')

        // si actualizo bien recien pasa a generar la liquidacion
        const res = await this.$store.dispatch('comisiones/generar_liquidacion', {
          periodo: this.periodo,
          familia: this.familia,
          debitos: this.debitos
        })

        this.dialog = false
        this.$swal.fire({
          icon: 'success',
          title: res.message
        })
      } catch (error) {
        this.$store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
      } finally {
        this.$store.state.loading = false
      }
    },
    async valdiar_periodo (periodo) {
      this.$store.state.loading = true
      await this.$store.dispatch('comisiones/validar_periodo', {
        periodo: periodo,
        familia: this.familia
      })
        .then(() => {
          this.periodo_valido = true
        })
        .catch(error => {
          this.periodo_valido = false
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error'
          })
        })
      this.$store.state.loading = false
    },
    async validar_archivo (event) {
      const files = event.target.files
      if (files) {
        // obtiene el archivo (en este caso solo puede subir 1)
        const file = files[0]
        const tipo = file.type

        // busca en el array de tipos_archivos el tipo de archivo del archivo que subio
        const tipo_archivo = tipos_archivos.find(a => a.mime == tipo)
        // verifica que exista el tipo de archivo en el array
        if (tipo_archivo) {
          // verifica que pertenezca por lo menos a un tipo de extension existente en el array de tipos
          if (this.tipos_validos.find(a => a == tipo_archivo.extension)) {
            // el archivo que subio es correcto, pasa a convertirlo a json
            this.convertir_json(file)
          }
          else {
            // subio un archivo con una extension no valida
            this.$store.dispatch('show_snackbar', {
              text: 'Tipo de archivo no válido',
              color: 'error'
            })
          }
        }
        else {
          // subio un tipo de archivo que no esta registrado en el array tipos_archivos
          this.$store.dispatch('show_snackbar', {
            text: 'Tipo de archivo no válido para el sistema',
            color: 'error'
          })
        }

        // limpia el input de archivos
        this.$refs.input.value = ''
      }
    },
    convertir_json (file) {
      try {
        const reader = new FileReader()
        reader.onload = (e) => {
          const bytes = e.target.result
          const excel = read(bytes, { type: 'binary', cellDates: true })
          // obtiene el nombre de la primer hoja
          const hoja_nombre = excel.SheetNames[0]
          // obtiene la primer hoja
          const hoja = excel.Sheets[hoja_nombre]
          // obtiene la data de la primer hoja
          const data = utils.sheet_to_json(hoja, { header: 1 })

          // cicla por cada row de la primer hoja (excluyendo los headers)
          this.debitos = []
          for (let i = 1; i < data.length; i++) {
            const row = data[i]
            // solo si la row tiene algun dato lo agrega al json
            if (row.length > 0) {
              this.debitos.push({
                preimpreso: row[0],
                debito_1: row[1],
                debito_2: row[2]
              })
            }
          }
          
          if (this.debitos.length > 0) {
            this.nombre_archivo = file.name
          }
          else {
            this.debitos = []
            this.nombre_archivo = ''
            this.$store.dispatch('show_snackbar', {
              text: 'El archivo cargado no contiene datos',
              color: 'warning',
              timeout: 3000
            })
          }
        }
        reader.readAsBinaryString(file)
      }
      catch (error) {
        this.debitos = []
        this.nombre_archivo = ''
        this.$store.dispatch('show_snackbar', {
          text: 'Ocurrio un error inesperado al convertir el archivo a JSON: ' + error,
          color: 'error',
          timeout: 4000
        })
      }
    }
  }
}
</script>
